import { ChatIndexScreen } from '~/chat/components/chat-screen/ChatIndexScreen';

export default ChatIndexScreen;
